import type { WebViewIntent } from '@/lib/react-native/services/react-native.intent'
import { createIntent } from '@/lib/react-native/services/react-native.intent'

export function createNativeToastIntent(
  color: 'success' | 'error' | 'info' | 'warning',
  handle: string | undefined,
  config?: {
    title?: string
    message?: string | null
    actionTitle?: string
    actionIntent?: WebViewIntent
  },
): WebViewIntent {
  return createIntent('DISPLAY_TOAST', {
    color,
    handle,
    title: config?.title,
    message: config?.message,
    actionLabel: config?.actionTitle,
    actionIntent: config?.actionIntent,
  })
}
